$(document).on('turbolinks:load', function() { 
    if ( $( "#questionSearchForm" ).length ) {
    $(questionSearchForm).on("ajax:success", function(event){
        [data, status, xhr] = event.detail
        $('#questions_search_result').html(data.getElementById("questions_search_result"));
    });
}
});

